import React from 'react'
import {
  DataMapper,
  DataTransformer,
  NullClickStrategy, 
  OnlyFilterActionDisplayStrategy, 
  TableFieldDescription,
  ConsolidatedSBOChipComponentCreator,
  StatusChipComponentCreator,
  DateTimeComponentCreator,
  DateTimeDisplayCreator,
} from '../../components/BPMTable/TableMapperCreator'
import * as f from '../../components/BPMTable/BPMInputs'
import { GraphQLDownloadFile } from '../../components/FileDownloader/FileComponentDownloader'
import {ExportFooterItemCreator} from "../../components/BPMTable/TableFooterItems"
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('consolidatedSboReport')}

class ConsolidatedSBOResultsTablerCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "ConsolidatedSBOResultsTablerCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, queries, new NullClickStrategy(), new OnlyFilterActionDisplayStrategy())
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);
        tableCreator.setInitialSortField('createdAt', 'desc')
        tableCreator.addDescriptions([
          new TableFieldDescription(
            'firstName',
              new DataMapper('user.firstName'),
              new f.FilterDescription(new f.TextFilter("firstName")),
              {label: 'User Name'}
        ),
        new TableFieldDescription(
            'lastName',
            new DataMapper('user.lastName'),
            new f.FilterDescription(new f.TextFilter("lastName")),
            {label: 'User Surname'}
        ),
        new TableFieldDescription(
            'enterpriseId',
            new DataMapper('user.enterpriseId'),
            new f.FilterDescription(new f.TextFilter("enterpriseId")),
            {label: 'User Id'}
        ),
        new TableFieldDescription(
            'filters',
            new DataMapper('vendors', 'vendors.name', 'periods', 'periods.date'),
            new f.FilterDescription(new f.NullCreator()),
            {
              label: 'Applied Filters', hideSort: true,
              transform: new DataTransformer(({periods, vendors})=> ({ periods:periods.map(p => p.date), vendors:vendors.map(v => v.name) })),
              componentCreator: new ConsolidatedSBOChipComponentCreator()
            }
        ),
        new TableFieldDescription(
          'createdAt',
          new DataMapper("createdAt"),
          new f.FilterDescription(new f.DateFilter("createdAt")),
          {
            label: 'Creation Date',
            componentCreator: new DateTimeComponentCreator(),
            excelDisplay: new DateTimeDisplayCreator()
          }
        ),
        new TableFieldDescription(
          'state',
          new DataMapper('state'),
          new f.FilterDescription(new f.ProcessControlStateFilter("state")),
          {label: 'State', componentCreator: new StatusChipComponentCreator()}
        ),
          new TableFieldDescription(
            'count',
            new DataMapper('totalCount', "currentCount"),
            new f.FilterDescription(new f.NullCreator()),
            {
              label: 'count', hideSort:true,
              transform: new DataTransformer(({totalCount, currentCount})=>`${currentCount} of ${totalCount}`)
            }
        ),
          new TableFieldDescription(
              'id',
              new DataMapper('id', 'state'),
              new f.FilterDescription(new f.NullCreator()),
              {
                label: 'File', hideSort:true,
                transform: new DataTransformer(({id, state})=> state === "FINISHED" ? <GraphQLDownloadFile resourceType='consolidated_sbo' id={id} /> : null)
              }
        ),

        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(ConsolidatedSBOResultsTablerCreator)

export default ConsolidatedSBOResultsTablerCreator;
